import React from "react";
import { translateService, dateHelperService } from "../../services/imports";

// What the validation shows for a cloud signing tool's signatures (the
// gateway's website prompts, §4-§5; owner, 2026-10-17). Phase A: validate.ge
// does not yet trust cloud signatures, so the validation shows them as
// untrusted - said plainly. Phase B, once the validation worker reads
// validate.ge's own trust list (the site setting
// validation_reads_validate_ge_trust_list): a signing tool's signatures count
// as trusted a few minutes (trust_list_propagation_minutes) after its
// certificate was installed. The gateway cannot tell which phase this is.

export const readsTrustList = () => !!globalConfig.validation_reads_validate_ge_trust_list;
const propagationMs = () => (Number(globalConfig.trust_list_propagation_minutes) || 5) * 60 * 1000;

const t = (k, ...a) => translateService.t(`notice.cloudSigner.${k}`, ...a);

// **word** in a text, bold
const withBold = (text) =>
  String(text || "")
    .split("**")
    .map((part, i) => (i % 2 ? <strong key={i}>{part}</strong> : <React.Fragment key={i}>{part}</React.Fragment>));

// On a cloud signing tool's card, and once in the add dialog (no signer yet):
// phase A the untrusted notice; phase B "trusted from {time}" until then,
// nothing after it
export function CloudSignerNotice({ signer }) {
  if (!readsTrustList())
    return (
      <div className="cloud-notice" role="note">
        <p className="cloud-notice__title">{t("untrusted.title")}</p>
        <p>{withBold(t("untrusted.text"))}</p>
      </div>
    );
  const installedAt = signer && signer.certificate && signer.certificate.installedAt;
  const from = installedAt ? installedAt + propagationMs() : null;
  if (!from || from <= Date.now()) return null;
  return (
    <div className="cloud-notice" role="note">
      <p>{t("propagation.text", dateHelperService.format(from, dateHelperService.smallDateTimeFormat))}</p>
    </div>
  );
}

// once in the signing flow, before the signatory commits (phase A only)
export function CloudFlowNotice() {
  if (readsTrustList()) return null;
  return (
    <p className="cloud-notice cloud-notice--short" role="note">
      {t("untrusted.short")}
    </p>
  );
}

// beside the validation result of a version a cloud signing tool signed
// (phase A only)
export function CloudResultNotice() {
  if (readsTrustList()) return null;
  return (
    <p className="cloud-notice cloud-notice--short" role="note">
      {t("untrusted.result")}
    </p>
  );
}
